import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import css from './css.module.less';

import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { get } from 'lodash';

import { useI18n } from 'src/hooks/useRouterChange';
import CollectionTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CollectionTable';
import ProductTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductTable';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;

export enum EProductsMatchRule {
  Any = 'Any',
  All = 'All ',
}
export enum EApplyTo {
  All = 'All',
  Collections = 'Collections',
  Products = 'Products',
}

const ProductsCollectionRadioTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    productTableName,
    collectionTableName,
    radioName,
    matchRuleName,
    productTableId,
    collectionTableId,
  } = props;
  // console.log('canDelete', canDelete);

  return (
    <React.Fragment>
      <ItemWrapper
        title={getI18n(
          'salesChannelDirectDiscount.discountValuebuyOne.conditionAppliesTo',
        )}>
        <Item name={radioName}>
          <RadioGroup className={css.radioGroup}>
            <RadioItem value={EApplyTo.All} className={css.radioFirst}>
              {getI18n(
                'salesChannelDirectDiscount.discountValuebuyOne.allProducts',
              )}
            </RadioItem>
            <RadioItem value={EApplyTo.Collections} className={css.radio}>
              {getI18n(
                'salesChannelDirectDiscount.discountValuebuyOne.specificCollections',
              )}
            </RadioItem>
            {matchRuleName && (
              <AnyAllRadio
                name={matchRuleName}
                dependencies={radioName}
                triggerName={EApplyTo.Collections}
                className={css.matchRuleGroup}
              />
            )}

            <RadioItem value={EApplyTo.Products}>
              {getI18n(
                'salesChannelDirectDiscount.discountValuebuyOne.specificProducts',
              )}
            </RadioItem>
            {matchRuleName && (
              <AnyAllRadio
                name={matchRuleName}
                dependencies={radioName}
                triggerName={EApplyTo.Products}
                className={css.lastRadioGroup}
              />
            )}
          </RadioGroup>
        </Item>
      </ItemWrapper>
      <_ProductTable
        name={productTableName}
        dependencies={radioName}
        triggerName={EApplyTo.Products}
        tableId={productTableId}
      />
      <_CollectionTable
        name={collectionTableName}
        dependencies={radioName}
        triggerName={EApplyTo.Collections}
        tableId={collectionTableId}
      />
    </React.Fragment>
  );
};
export default ProductsCollectionRadioTable;

const _ProductTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { name, dependencies, triggerName, tableId } = props;
  return (
    <Item
      shouldUpdate={(p, c) => {
        const pV = get(p, dependencies);
        const cV = get(c, dependencies);
        return pV !== cV;
      }}>
      {({ getFieldValue }) => {
        const v = getFieldValue(dependencies);
        if (v === triggerName) {
          return (
            <div className={css.tableContainer}>
              <Item
                name={name}
                rules={[
                  {
                    validator: async (x, value) => {
                      if ((value || []).length < 1) {
                        return Promise.reject(
                          new Error(
                            getI18n(
                              'general.advancedFilters.commonRadioMulSelect.selectItem',
                            ),
                          ),
                        );
                      }
                    },
                  },
                ]}>
                <ProductTable tableId={tableId} />
              </Item>
            </div>
          );
        }
        return null;
      }}
    </Item>
  );
};

const _CollectionTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { name, dependencies, triggerName, tableId } = props;
  return (
    <Item
      shouldUpdate={(p, c) => {
        const pV = get(p, dependencies);
        const cV = get(c, dependencies);
        return pV !== cV;
      }}>
      {({ getFieldValue }) => {
        const v = getFieldValue(dependencies);
        if (v === triggerName) {
          return (
            <div className={css.tableContainer}>
              <Item
                name={name}
                rules={[
                  {
                    validator: async (x, value) => {
                      if ((value || []).length < 1) {
                        return Promise.reject(
                          new Error(
                            getI18n(
                              'general.advancedFilters.commonRadioMulSelect.selectItem',
                            ),
                          ),
                        );
                      }
                    },
                  },
                ]}>
                <CollectionTable tableId={tableId} />
              </Item>
            </div>
          );
        }
        return null;
      }}
    </Item>
  );
};
//general.status.all
const AnyAllRadio = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { name, dependencies, triggerName, className } = props;
  return (
    <Item
      shouldUpdate={(p, c) => {
        const pV = get(p, dependencies);
        const cV = get(c, dependencies);
        return pV !== cV;
      }}>
      {({ getFieldValue }) => {
        const v = getFieldValue(dependencies);

        if (v === triggerName) {
          return (
            <Item
              name={name}
              rules={[
                {
                  required: true,
                  message: getI18n('general.pleaseselectavalue'),
                },
              ]}>
              <RadioGroup className={`${css.radioGroup} ${className || ''}`}>
                <RadioItem value={EProductsMatchRule.All} className={css.radio}>
                  {getI18n('general.status.all')}
                </RadioItem>
                <RadioItem value={EProductsMatchRule.Any} className={css.radio}>
                  {getI18n('general.any')}
                </RadioItem>
              </RadioGroup>
            </Item>
          );
        }
        return null;
      }}
    </Item>
  );
};
